import { cssRule } from "typestyle";

cssRule("html, body, .mainWrapper", {
  fontFamily: "Inter Variable",
  height: "100%",
  margin: 0,
  padding: 0,
  width: "100%",
});

cssRule("*", {
  outline: "none",
});

// clear background for our react-to-html icons (using L.DivIcon)
cssRule(".leaflet-div-icon", { background: "unset", border: "none" });
